var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagLevel,{tag:"component",class:[
    'occ-heading',
    ("occ-heading--" + _vm.visualLevel),
    ("occ-heading__color--" + _vm.color),
    _vm.align ? ("occ-heading__align--" + _vm.align) : '',
    _vm.weight ? ("occ-heading__weight--" + _vm.weight) : ''
  ],style:(_vm.lineClampClassName)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }